import React, { useEffect, useState } from 'react'

import { Divider, styled } from '@mui/material';
import Recruit_Schedule from 'src/components/adminRecruit/Recruit_Schedule';
import Recruit_Calendar from 'src/components/adminRecruit/Recruit_Calendar';
import { useFetchRecruitSchedule } from 'src/components/adminRecruit/useLoadRecruitSchedule';
import { useAdRecruitStore } from 'src/stores/AdRecruitStore';

const PageWrapper = styled('div')(({theme})=>({
  margin : '30px 30px',
  backgroundColor:'white',
  borderRadius:'10px',
  height: 'calc(100vh - 126px)', // 필요시 조정
  overflow: 'hidden', // 전체적으로 overflow 방지
}))

const StatusWrapper = styled('div')(({theme})=>({
  display: 'flex',
  justifyContent:'space-around',
  alignItems:'center',

  width:'100%'
}))

const StatusContainer = styled('button',{
  shouldForwardProp: (prop) => prop !== 'status',
})<{ status: boolean }>(({ theme, status })=>({
  all:'unset',
  display:'flex',
  justifyContent:'center',
  alignItems:'center',
  gap:'10px',
  
  width:'100%',
  padding:'24px',
  position:'relative',
  cursor:'pointer',
  color: status ? '#30515B' : '#AAAAAA',
  fontSize:'18px',
  fontWeight:'bold',
  whiteSpace:'nowrap'
}))

const Dividersx ={
  width: '95%', 
  height: '2px', 
  backgroundColor: '#30515B', 
  bottom:0, 
  position:'absolute'
}

type statusType = '모집 일정' | '캘린더' 

const AdRecruitPage = () => {
  const [tap, setTap] = useState<statusType>('모집 일정')
  const { fetchData } = useFetchRecruitSchedule();
  const type = useAdRecruitStore((state)=>state.type)
  const sort_order = useAdRecruitStore((state)=>state.sort_order)
  const page = useAdRecruitStore((state)=>state.page)
  const status = useAdRecruitStore((state)=>state.status)
  const pageSize = useAdRecruitStore((state)=>state.pageSize)

  const reset = useAdRecruitStore((state)=>state.reset)

  useEffect(()=>{
    return(()=>{
        reset()
    }
    )
  },[])  

  useEffect(()=>{
  fetchData()
  },[page,sort_order,type,status,pageSize])

  return (
    <PageWrapper>
      <StatusWrapper>
        <StatusContainer status={tap === '모집 일정'} onClick={()=>setTap('모집 일정')}>모집 일정{tap === '모집 일정' && <Divider sx={Dividersx}/>}</StatusContainer>
        <StatusContainer status={tap === '캘린더'} onClick={()=>setTap('캘린더')}>캘린더{tap === '캘린더' && <Divider sx={Dividersx}/>}</StatusContainer>
      </StatusWrapper>
      {tap === '모집 일정' && <Recruit_Schedule/> }
      {tap === '캘린더' && <Recruit_Calendar/> }
    </PageWrapper>
  )
}

export default AdRecruitPage